import React from 'react';
import styled from 'styled-components';

export const ProductImage = styled.img`
	width: 100%;
`;

export const ProductInfo = styled.div`
	margin-bottom: 16px;
`;

export const ProductName = styled.h2`
	font-size: 2rem;
	margin: 0 0 8px 0;
`;

export const ProductPrice = styled.p`
	font-size: 2rem;
	font-weight: bold;
	margin: 0 0 16px 0;
`;
